//  Copyright (c) 2020 First Foundry Inc. All rights reserved.

export const PATH = 'products/table'
export const SET_SORT = `${PATH}/SET_SORT `
export const SET_PAGE = `${PATH}/SET_PAGE`
export const SET_SEARCH_TERM = `${PATH}/SET_SEARCH_TERM`
export const SET_RESULT = `${PATH}/SET_RESULT`
export const SET_FILTERS = `${PATH}/SET_FILTERS`
